class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.menuItems = this.querySelectorAll('.mega-menu');
    this.setupHoverHandlers();
  }

  setupHoverHandlers() {
    this.menuItems.forEach(menuItem => {
      const summary = menuItem.querySelector('summary');
      const content = menuItem.querySelector('.mega-menu__content');
      let timeout;

      // Open menu on hover
      summary.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
        menuItem.setAttribute('open', '');
      });

      // Close menu when mouse leaves
      menuItem.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          menuItem.removeAttribute('open');
        }, 200); // Small delay to prevent flickering
      });

      // Prevent closing when hovering over content
      content.addEventListener('mouseenter', () => {
        clearTimeout(timeout);
      });

      // Close menu when mouse leaves content
      content.addEventListener('mouseleave', () => {
        timeout = setTimeout(() => {
          menuItem.removeAttribute('open');
        }, 200);
      });
    });
  }
}

customElements.define('header-menu', MegaMenu); 